import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";
import { formatDateTime } from "../../../../common/Validations";

const JobCardQuantityDetails = (props) => {
  //const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  // const handleClose = () => {
  //   setOpen(false);
  // };
  // const handleOpen = (data) => {
  //   setOpen(true);
  // };

  // OK Count
  const columnsData2 = [
    {
      name: t("msg_reports.msg_production_status.count"),
      selector: (row) => row.okCount,
      sortable: true,
      width: "100px",
      center: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.okCount} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.operator_Name"),
      selector: (row) => row.okCount,
      sortable: true,
      width: "150px",
      center: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.user} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.date"),
      selector: (row) => row.okCount,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row.date)} </p>
        </div>
      ),
    },
  ];

  // Reject Count
  const columnsData3 = [
    {
      name: t("msg_reports.msg_production_status.count"),
      selector: (row) => row.rejectCount,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.rejectCount} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.operator_Name"),
      selector: (row) => row.user,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.user} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.reject_reason"),
      selector: (row) => row.user,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.rejectReason} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.date"),
      selector: (row) => row.date,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row.date)} </p>
        </div>
      ),
    },
  ];

  // Rework Count
  const columnsData4 = [
    {
      name: t("msg_reports.msg_production_status.rework_ok"),
      selector: (row) => row.user,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reworkOk} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.rework_reject"),
      selector: (row) => row.user,
      sortable: true,
      width: "140px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reworkReject} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.operator_Name"),
      selector: (row) => row.user,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.user} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.rework_fromdept"),
      selector: (row) => row.reworkDeptCode,
      sortable: true,
      width: "220px",
      cell: (row) => (
        <>
          {row.reworkDeptCode ? (
            <span className="m-0 p-0 pt-1 fw-datatable-row">
              {row.reworkDeptCode} - {row.reworkDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.date"),
      selector: (row) => row.date,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row.date)} </p>
        </div>
      ),
    },
  ];

  // CONSUMPTION Count
  const columnsData5 = [
    {
      name: t("msg_reports.msg_production_status.consumptionShot"),
      selector: (row) => row.count,
      sortable: true,
      width: "140px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.consumptionType} </p>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.consumableSize}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.count"),
      selector: (row) => row.count,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.count} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.operator_Name"),
      selector: (row) => row.user,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.user} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.date"),
      selector: (row) => row.date,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row.date)} </p>
        </div>
      ),
    },
  ];

  // Main Table Col
  const columnsData = [
    {
      name: t("msg_reports.msg_production_status.department"),
      selector: (row) => row.dept,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.dept} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.ok"),
      selector: (row) => row.ok,
      sortable: true,
      width: "400px",
      className: "center-header",
      cell: (row) => (
        <div className="jobcard-report-grid">
          <MasterList
            columnsData={columnsData2}
            rowsData={row.ok}
            cardHeader={false}
            dense
          />
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.reject"),
      selector: (row) => row.reject,
      sortable: true,
      width: "550px",
      className: "center-header",
      cell: (row) => (
        <div className="jobcard-report-grid">
          <MasterList
            columnsData={columnsData3}
            rowsData={row.reject}
            cardHeader={false}
            dense
          />
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.consumption"),
      selector: (row) => row.consumption,
      sortable: true,
      width: "550px",
      className: "center-header",
      cell: (row) => (
        <div className="jobcard-report-grid">
          <MasterList
            columnsData={columnsData5}
            rowsData={row.consumption}
            cardHeader={false}
            dense
          />
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.rework"),
      selector: (row) => row.rework,
      sortable: true,
      width: "500px",
      className: "center-header",
      cell: (row) => (
        <div className="jobcard-report-grid">
          <MasterList
            columnsData={columnsData4}
            rowsData={row.rework}
            cardHeader={false}
            dense
          />
        </div>
      ),
    },
  ];
  const { onHide } = props;
  // console.log(">>>>>>>>>",props)
  return (
    <Modal
      {...props}
      onHide={onHide}
      animation={false}
      dialogClassName="modal-90w"
      backdrop="static"
    >
      <ModalHeader
        title={` ${t(
          "msg_reports.msg_production_status.job_card_quantity_details"
        )} - ${props.jobcard} `}
      ></ModalHeader>
      <ModalBody>
        <MasterList
          columnsData={columnsData}
          rowsData={props.rowsData}
          pagination={false}
          handleClose
          cardHeader={false}
          //handleOpen={handleOpen}
          //handleDelete={confirmBeforeDelete}
          //onSelectedRowsChange={handleRowSelected}
        />
      </ModalBody>
    </Modal>
  );
};

export default JobCardQuantityDetails;
